import type { ReactElement } from 'react';

/**
 * Repeats of "BETA" in one half; the track renders two identical halves and
 * scrolls exactly -50%, so the loop is seamless. One half must be at least as
 * wide as the viewport or a gap appears at the wrap — hence the generous count
 * (cheap in the DOM, safe up to ultra-wide screens).
 */
const BETA_HALF = Array.from({ length: 40 }, (_, i) => <span key={i}>BETA</span>);

/**
 * BetaTicker — приглушённая бегущая строка "BETA" в подвале, одинаково на всех
 * экранах (дизайн-система 02 §9: полоса ink-950, пиксельный "BETA" gold-400). Полоса не оверлей: её высота зарезервирована через
 * `--cards-beta-ticker-reserve`, которую полноэкранные контейнеры вычитают из
 * своей высоты — весь сайт адаптируется так, будто экран короче на эту полосу.
 *
 * Seamless-петля через `translateX(-50%)` двух идентичных половин; анимируем
 * только `transform` (не left/margin), иначе рывки (см. аудит UI). Уважает
 * prefers-reduced-motion и safe-area.
 */
export const BETA_TICKER_STYLES = `
  :root {
    --cards-beta-ticker-h: 22px;
    --cards-beta-ticker-reserve: calc(var(--cards-beta-ticker-h) + env(safe-area-inset-bottom, 0px));
  }
  .cards-beta-ticker {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 90;
    box-sizing: border-box;
    height: var(--cards-beta-ticker-reserve);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    display: flex;
    align-items: center;
    overflow: hidden;
    pointer-events: none;
    background: var(--c-step-shadow);
    user-select: none;
  }
  .cards-beta-ticker-track {
    display: flex;
    flex: 0 0 auto;
    white-space: nowrap;
    animation: cards-beta-ticker-scroll var(--dur-ticker) linear infinite;
    will-change: transform;
  }
  .cards-beta-ticker-track > span {
    flex: 0 0 auto;
    padding: 0 var(--space-8);
    font: var(--type-display-3xs);
    text-transform: uppercase;
    color: var(--c-selection);
    opacity: .55;
  }
  @keyframes cards-beta-ticker-scroll {
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
  }
  @media (prefers-reduced-motion: reduce) {
    .cards-beta-ticker-track { animation: none; }
  }
`;

/** Fixed footer marquee shown identically on every screen. */
export function BetaTicker(): ReactElement {
  return (
    <div className="cards-beta-ticker" aria-hidden="true">
      <div className="cards-beta-ticker-track">
        {BETA_HALF}
        {BETA_HALF}
      </div>
    </div>
  );
}
